export default function Disclaimer() {
    return (
        <div className="py-8 space-y-8 font-RedditMono">
            <div className="relative">
            <div className="absolute w-full h-full bg-black opacity-75 rounded-lg transform md:translate-x-4 translate-y-4"></div>
                <div className="relative text-center space-y-12 rounded-lg bg-teal-200 p-14 border-4 border-black">
                    <div className="font-bold">DISCLAIMER: $GRAPES is a meme coin with no intrinsic value or expectation of financial return. <br></br>$GRAPES is not associated with the The Duck Song creation by Bryant Oden and Forrest Whaley.</div>
                    <div>CA: 0x2e0fC9DBa6E31740B6231d7faa00CDa89054DD31</div>
                </div>
            </div>
            <div className="relative">
                <div className="absolute w-full h-full bg-black opacity-75 rounded-lg transform md:translate-x-4 translate-y-4"></div>
                <div className="relative text-center space-y-12 rounded-lg bg-white p-8 border-4 border-black">
                    <div>For your smart contract and website building needs contact: benjaminduffield1997@gmail.com</div>
                </div>
            </div>
        </div>
    );
}